"use client";
import React, { useRef, useEffect } from "react";
import "../styles/Certificatepg.css";

import Beams from "./Beams"; 
import certificateGif from "../assets/certify.gif"; // ✅ Import your GIF

const Certificatepg = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const form = useRef();

  return (
    <div className="certificatepg-container">
      <div className="certificate-header">
        <h1>Certifications</h1>
        <p>
          Acume understands the importance of providing quality, safe and clean services to the clients which is the vital part of being a successful service provider.<br />
          We have developed our management system which incorporates Quality, OH&S and EMS.
        </p>
      </div>

      {/* Right Side GIF */}
      <div className="certificatepg-gif">
        <img src={certificateGif} alt="Certificate GIF" />
      </div>

      <div className="cer-silk-bg">
         <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
      </div>
    </div>
  );
};

export default Certificatepg;
